import * as api from '../api'
import { endLoading, startLoading } from '../reducers/contactUsSlice';

export const createContactUsMessage = (formData) => async(dispatch) => {
    try{
        dispatch({ type: startLoading.type })
        const {data} = await api.createContactUsMessage(formData);
        // dispatch({
        //     type: setContactMessage.type,
        //     payload: data
        // })
        dispatch({ type: endLoading.type })
        return data
    }catch(error){
        // console.log(error)
    }
}